// tslint:disable-next-line
import log from 'loglevel';

export const Logger = log;

const methodFactory = Logger.methodFactory;

Logger.methodFactory = (methodName, level, loggerName) => {
  const logger = methodFactory(methodName, level, loggerName);

  if (loggerName !== undefined && loggerName !== 'String') {
    const prefix = `%c[ ${String(loggerName)} ]`;

    return logger.bind(
      function (...args) {
        console.log(...args);
      },
      prefix,
      'font-size: 10px; font-weight: bold'
    );
  } else {
    return logger;
  }
};

export function loggerFor(name: string): log.Logger {
  return Logger.getLogger(name);
}
